var t=(t,r=[])=>{try{return Reflect.construct(t,r)}catch(c){return t(...r)}};export{t as default};